import { makeStyles } from '@material-ui/core';
import { corDaSituacao, FAMILIAS } from 'utils/situacao';

const { texto, solido } = corDaSituacao(FAMILIAS.PENDENTE);

export const useStyles = makeStyles(() => ({
  vlWaiting: {
    borderLeft: `2px solid ${solido}`,
    position: 'absolute',
    height: '80px',
    marginLeft: '30px',
  },
  hlWaiting: {
    borderLeft: `2px solid ${texto}`,
    position: 'absolute',
    height: '28px',
    marginLeft: '44px',
    marginTop: 63,
    transform: 'rotate(90deg)',
  },
  avatarWaiting: {
    width: '52px',
    height: '52px',
    border: `2px solid ${solido}`,
  },
  iconWaiting: {
    position: 'absolute',
    marginLeft: 26,
    marginTop: 72,
    fontSize: 10,
    color: texto,
  },
}));
